import { IconButton } from "@chakra-ui/react";
import { Box, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/react";
import { tooltipDownAnimation } from "./customTheme";
import { DotsIcons, MetaImageContainer } from "./UiElements";
import layoutStore from "../stores/layoutStore";

const ItemImage =({ groupId, id, data, hoverItem }: any) => { 
    const iconBG = useColorModeValue('gray.100', '#32363A');
    const iconBGHover = useColorModeValue('gray.200', '#32363A');
    const iconDarkerColor = useColorModeValue('gray.600', '#A1A2A4');
    let setSiteModalOpen = layoutStore((state) => state.setSiteModalOpen);
    const siteModalOpen =
        layoutStore((state) => state.siteModalOpen) === id;

    const openTabModal = (e) => {
        e.stopPropagation();
        setSiteModalOpen({ groupId: groupId, ...data });
    };
    
    return (
        <>
        <MetaImageContainer
            metaUrl={data.imageUrl}
            hover={hoverItem}
            />
            <Flex position="absolute" right="4px" top="12px">
                    <Box
                        ml="4px"
                        mr="12px"
                        opacity={hoverItem && !siteModalOpen ? 1 : 0}
                        transition="0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275)"
                        transform={
                            hoverItem && !siteModalOpen
                                ? 'scale(1)'
                                : 'scale(0)'
                        }
                    >
                            <Tooltip
                                label="Edit"
                                zIndex="1000"
                                motionProps={tooltipDownAnimation}
                                placement="bottom"
                                rounded="6px"
                            >
                                <IconButton
                                    aria-label="Edit"
                                    icon={<DotsIcons size={'14px'} />}
                                    //onClick={() => deleteNote(spaceId, tabId, "Text-snippet")}
                                    onClick={openTabModal}
                                    color={iconDarkerColor}
                                    minWidth="28px"
                                    height="28px"
                                    bg={iconBG}
                                    _hover={{
                                        bg: iconBGHover
                                    }}
                                    //returnFocusOnClose={false}
                    />
                </Tooltip>
            </Box>
        </Flex>
        </>
    );
}

export default ItemImage;
